<div style="display:block;padding-top:10px;">
<app-data-table [columns]="tableColumns" [value]="dependents" [sortField]="DefaultSortField"
                [rightCaptionTemplate]="rightCaption" [disableSearch]="true">

  <ng-template #rightCaption>
    <button pButton type="button" class="action-secondary"
            icon="fa fa-plus" label="Dependent"
            pTooltip="Make New Dependent" tooltipPosition="top"
            (click)="onClickAddDependent()">
    </button>
  </ng-template>

  <ng-template #dependentAction let-row="row">
    <button pButton type="button"
            class="icon-action" icon="fa fa-pencil"
            pTooltip="Update" tooltipPosition="top"
            (click)="onClickEditDependent(row)">
    </button>
    <button pButton type="button"
            class="icon-negative" icon="fa fa-trash"
            pTooltip="Delete" tooltipPosition="top"
            (click)="onClickDeleteDependent(row)">
    </button>
  </ng-template>

</app-data-table>
</div>

<p-confirmDialog></p-confirmDialog>

<!-- dialog for new Dependent or editing an existing Dependent -->
<p-dialog *ngIf="dependentToEdit" [(visible)]="displayDialog"
          header="Dependents"
          [dismissableMask]="true" [responsive]="true"
          [modal]="true" [style]="PrimeNgConfig.DialogStyle40">
  <form class="p-grid" #dialogForm="ngForm">

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Dependent Type*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-dropdown name="dependentType" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                  [options]="dependentTypeDropDown" [(ngModel)]="dependentToEdit.type"
                  required></p-dropdown>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>First Name*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <input pInputText name="firstName"
             type="text" [maxlength]="Validation.TextMaxLength"
             [(ngModel)]="dependentToEdit.firstName"
             required/>
      <div *ngIf="dependentToEdit?.firstName?.length >= Validation.TextMaxLength" class="alert alert-danger" style="width:225px;">
        {{Validation.MaxNumOfCharsExceeded}}
      </div>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Middle Name</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <input pInputText name="middleName"
             type="text"
             [maxlength]="Validation.TextMaxLength"
             [(ngModel)]="dependentToEdit.middleName"/>
      <div *ngIf="dependentToEdit?.middleName?.length >= Validation.TextMaxLength" class="alert alert-danger" style="width:225px;">
        {{Validation.MaxNumOfCharsExceeded}}
      </div>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Last Name*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <input pInputText name="lastName"
             type="text" [maxlength]="Validation.TextMaxLength"
             [(ngModel)]="dependentToEdit.lastName"
             required/>
      <div *ngIf="dependentToEdit?.lastName?.length >= Validation.TextMaxLength" class="alert alert-danger" style="width:225px;">
        {{Validation.MaxNumOfCharsExceeded}}
      </div>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>SSN*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <!-- <p-inputMask [(ngModel)]="dependentToEdit.ssn" [mask]="Format.SocialSecurityMask" [placeholder]="Format.SocialSecurityMask" id="ssn" name="ssn" [unmask]="true" required></p-inputMask> -->

      <span *ngIf="dependentToEdit.id">
        <span *ngIf="showEditSSN">
          <p-inputMask name="ssn" [placeholder]="Format.SocialSecurityMask" [(ngModel)]="dependentToEdit.ssn" required [mask]="Format.SocialSecurityMask" [unmask]="true"></p-inputMask>
          <button pButton class="icon-action" icon="fa fa-check" (click)="showEditSSN = !showEditSSN" [disabled]="9 > dependentToEdit.ssn?.length "></button>
        </span>
        <span *ngIf="!showEditSSN" class="ssn-masking">
          {{dependentToEdit.ssn | ssnMask}}
          <button pButton class="icon-action" icon="fa fa-pencil" (click)="showEditSSN = !showEditSSN"></button>
        </span>
      </span>
      <span *ngIf="!dependentToEdit.id">
        <p-inputMask name="ssn" [placeholder]="Format.SocialSecurityMask" [(ngModel)]="dependentToEdit.ssn" required [mask]="Format.SocialSecurityMask" [unmask]="true"></p-inputMask>
      </span>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Date Of Birth*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-calendar name="dob" dataType="string" [dateFormat]="Format.PcalendarDate"
                  [maxDate]="maxDobEndOn" icon="fa fa-calendar" showIcon="true"
                  [placeholder]="PrimeNgConfig.CalendarPlaceholder" [(ngModel)]="dependentToEdit.dateOfBirth"
                  required [monthNavigator]="true" [yearNavigator]="true" [yearRange]="DependentBirthYearRange"
                  readonlyInput="true"></p-calendar>
    </div>

  </form>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <!-- disable it until all required field including chargeCodeId are selected -->
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel" (click)="displayDialog=false"></button>
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Add" (click)="onClickSaveDependent(dependentToEdit)" [disabled]="!dialogForm.form.valid"></button>
    </div>
  </p-footer>
</p-dialog>
